module.exports = __webpack_public_path__ + "img/mixerTruk-gray.25add007.svg";